(function () {
  var PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function markReady(wrapper) {
    if (wrapper) wrapper.classList.add('is-hover-ready');
  }

  function isRealHoverSrc(img) {
    var src = img.currentSrc || img.src || '';
    return src.indexOf('data:') !== 0 && src.length > 0;
  }

  function loadHoverImg(img, wrapper) {
    if (!img) return;
    if (img.dataset.rioHoverLoaded === '1') {
      if (isRealHoverSrc(img) && img.complete && img.naturalWidth > 1) markReady(wrapper);
      return;
    }
    var src = img.getAttribute('data-rio-hover-src');
    var srcset = img.getAttribute('data-rio-hover-srcset');
    if (!src && !srcset) return;

    var onReady = function () {
      if (isRealHoverSrc(img) && img.naturalWidth > 1) markReady(wrapper);
    };
    img.addEventListener('load', onReady);
    img.addEventListener(
      'error',
      function () {
        img.removeEventListener('load', onReady);
        img.src = PLACEHOLDER;
        img.removeAttribute('srcset');
        img.dataset.rioHoverLoaded = '';
      },
      { once: true }
    );

    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.dataset.rioHoverLoaded = '1';
    if (img.complete && isRealHoverSrc(img) && img.naturalWidth > 1) onReady();
  }

  function bindCard(wrapper) {
    if (wrapper.dataset.rioHoverBound === '1') return;
    wrapper.dataset.rioHoverBound = '1';
    var img = wrapper.querySelector('img[data-rio-hover-src]');
    if (!img) return;
    var card = wrapper.closest('.product-card__wrapper') || wrapper;
    var onEnter = function () {
      loadHoverImg(img, wrapper);
    };
    card.addEventListener('pointerenter', onEnter, { passive: true });
    card.addEventListener('focusin', onEnter);
  }

  function bindCollectionSecond(el) {
    if (el.dataset.rioHoverBound === '1') return;
    el.dataset.rioHoverBound = '1';
    var img = el.querySelector('img[data-rio-hover-src]');
    if (!img) return;
    var slide = el.closest('.swiper-slide');
    var maybeLoad = function () {
      if (!slide || slide.classList.contains('swiper-slide-active')) loadHoverImg(img, el);
    };
    if (slide) {
      new MutationObserver(maybeLoad).observe(slide, { attributes: true, attributeFilter: ['class'] });
    }
    maybeLoad();
  }

  function hydrateDeferred(img) {
    if (!img || img.dataset.rioDeferredLoaded === '1') return;
    var src = img.getAttribute('data-rio-deferred-src');
    var srcset = img.getAttribute('data-rio-deferred-srcset');
    if (!src && !srcset) return;
    img.dataset.rioDeferredLoaded = '1';
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
  }

  function bindDeferred(img) {
    if (!img || img.dataset.rioDeferredBound === '1') return;
    img.dataset.rioDeferredBound = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateDeferred(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(img);
    } else {
      hydrateDeferred(img);
    }
  }

  function init() {
    document.querySelectorAll('[data-rio-hover-media]').forEach(bindCard);
    document.querySelectorAll('[data-rio-hover-collection]').forEach(bindCollectionSecond);
    document.querySelectorAll('img[data-rio-deferred-src]').forEach(bindDeferred);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
